module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Moenthal-278104ba727a93299ffe723fd69d5a19.svg";